<template>
    <div class="OfficeAdd" v-if="lang">
        <div class="header header-mobile">
            <aside class="step">
                <div class="circle active">&nbsp;</div>
                <span class="active">{{ translate.pages.office.add.tabs.address.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div class="circle" :class="{ active: steps.two.active }"></div>
                <span :class="{ active: steps.two.active }">{{ translate.pages.office.add.tabs.specialities.title }}</span>
            </aside>
        </div>
        <br>
        <div class="content">
            <div v-if="steps.one.active">
                <header class="content-header">
                    <h3>{{ translate.pages.office.add.tabs.address.title }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                <label>{{ translate.pages.office.add.fields.name }}</label>
                                <md-input
                                type="text" v-model="data.name"></md-input>
                                
                                <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.street.invalid }">
                                <label>{{ translate.pages.office.add.fields.street }}</label>
                                <md-input type="text" v-model="data.street"></md-input>
                                <span class="md-error" v-if="errors.street.invalid">{{ errors.street.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.number.invalid }">
                                <label>{{ translate.pages.office.add.fields.number }}</label>
                                <md-input type="text" v-model="data.number"></md-input>
                                <div class="marcaagua">ej: 1234</div>
                                <span class="md-error" v-if="errors.number.invalid">{{ errors.number.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container md-input-container masked_input" style="margin-bottom: 27px !important;" :class="{ 'md-input-invalid' : errors.region_id.invalid }">
                            <vue-select
                                :options="regions"
                                :placeholder="placeholder_provincia"
                                :on-change="changeRegion"
                                v-model="data.region.label"
                                class="md-input select2"
                                style="width: 100%;"
                                >
                                <span slot="no-options">No se encontraron resultados.</span>
                            </vue-select>
                            <span class="md-error" v-if="errors.region_id.invalid">{{ errors.region_id.msg }}</span>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container md-input-container masked_input" style="margin-bottom: 27px !important;" :class="{ 'md-input-invalid' : errors.comunity.invalid }">
                            <vue-select
                                :options="comunities"
                                placeholder="Comuna"
                                :on-change="changeCity"
                                v-model="data.city.label"
                                style="width: 100%;"
                                class="md-input select2"
                                >
                                <span slot="no-options">No se encontraron resultados.</span>
                            </vue-select>
                            <span class="md-error" v-if="errors.comunity.invalid">{{ errors.comunity.msg }}</span>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.phone.invalid }">
                                <label>{{ translate.pages.office.add.fields.phone }}</label>
                                <md-input type="text" v-model="data.phone"
                                v-validate
                                data-vv-rules="required|numeric|min:6|max:12"
                                ></md-input>
                                <div class="marcaagua">ej: 912345</div>
                                <span class="md-error" v-if="errors.phone.invalid">{{ errors.phone.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <div v-else>
                <header class="content-header">
                    <h3>{{ translate.pages.office.add.tabs.specialities.title }}</h3>
                </header>
                <main class="content-main">
                    <md-layout md-gutter>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <div class="multiple checkbox-list" :class="{ 'error' : errors.speciality.invalid }">
                                <p>{{ translate.pages.office.add.fields.specialities }}</p>
                                <div class="select">
                                    <md-checkbox class="option text--color" v-for="speciality in specialities" :key="speciality.id" @change="onChosen($event,speciality.id)" v-model="speciality.checked">{{ speciality.name }}</md-checkbox>
                                </div>
                            </div>
                            <label class="subtitle" :class="{ 'error' : errors.speciality.invalid }">{{ translate.pages.office.add.fields.selects_specialties }}</label>
                        </md-layout>

                        <md-layout md-flex-small="100" md-flex="50" class="container h10">
                            <md-input-container :class="{ 'md-input-invalid' : errors.duration.invalid }">
                                <label>{{ translate.pages.office.add.fields.duration }}</label>

                                <md-select v-model="data.duration">
                                    <md-option  value="10">10</md-option>
                                    <md-option  value="20">20</md-option>
                                    <md-option  value="30">30</md-option>
                                    <md-option  value="40">40</md-option>
                                    <md-option  value="50">50</md-option>
                                    <md-option  value="60">60</md-option>
                                    <md-option  value="70">70</md-option>
                                    <md-option  value="80">80</md-option>
                                    <md-option  value="90">90</md-option>
                                    <md-option  value="100">100</md-option>
                                    <md-option  value="110">110</md-option>
                                    <md-option  value="120">120</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.duration.invalid">{{ errors.duration.msg }}</span>
                            </md-input-container>
                        </md-layout>

                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.hour_confirm.invalid }">
                                <label>{{ translate.pages.office.add.fields.hour_confirm }}</label>
                                <md-input type="text" v-model="data.hour_confirm"></md-input>
                                <md-select v-model="data.hour_confirm">
                                    <md-option  value="4">4</md-option>
                                    <md-option  value="6">6</md-option>
                                    <md-option  value="12">12</md-option>
                                    <md-option  value="24">24</md-option>
                                    <md-option  value="36">36</md-option>
                                    <md-option  value="48">48</md-option>
                                </md-select>

                                <span class="md-error" v-if="errors.hour_confirm.invalid">{{ errors.hour_confirm.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container" style="padding:1.25em">
                            <md-checkbox md-theme="green" class="md-primary text--color" v-model="data.add_user">
                                {{ translate.pages.office.add.fields.add_user }}
                            </md-checkbox>
                        </md-layout>
                    </md-layout>
                </main>
            </div>
            <footer class="content-footer">
                <hr>
                <div class="buttons clearfix">
                    <div class="return">
                        <router-link v-if="steps.button" :to="{ name: 'Office' }" class="md-button md-raised md-size btn--gray masked_btn"><md-icon>keyboard_arrow_left</md-icon> {{ translate.actions.previous }}</router-link>
                        <md-button class="md-raised md-size btn--gray" v-if="!steps.button" @click.native="previous"><md-icon>keyboard_arrow_left</md-icon> {{ translate.actions.previous }}</md-button>
                    </div>
                    <div class="next">
                        <md-button class="md-raised md-primary md-size btn--blue" @click.native="next" :disabled="process">{{ translate.actions.next }} <md-icon>keyboard_arrow_right</md-icon></md-button>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
    import { doctor, public_api } from '../../../config/api.js';
    const swal = require('sweetalert2');
    import vueSelect from "vue-select";
    export default {
        components: {vueSelect},
        created() {
            this.getRegionPlaceHolder()
            // Get Profile
            this.$http.get('/doctor/me', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        let data = response.data.data;
                        this.doctor = data;
                        if(this.doctor.is_institution){
                            this.data.phone = this.doctor.phone;
                            this.data.street = this.doctor.street;
                            this.data.number = this.doctor.number;
                        }

            var country = { "country": this.$route.params.country.toUpperCase() };
            // Get Regions
            this.$http.post(doctor.api.regions, country, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    data.map((item, index) => {
                        item.value = item.geonameId;
                        item.label = item.toponymName;
                        if(this.doctor.is_institution){
                            this.data.phone = this.doctor.phone;
                            this.data.street = this.doctor.street;
                            this.data.number = this.doctor.number;
                            if(item.geonameId == this.doctor.region_id){
                                this.data.region.label = item.label;
                                this.data.region.value = item.value;
                                this.$http.post(public_api.api.cities, {region: this.data.region.value})
                                    .then(response => {
                                        let data = response.data.data;
                                        data.map(_item => {
                                            _item.value = _item.geonameId
                                            _item.label = _item.toponymName
                                            if(_item.toponymName == this.doctor.comunity){
                                                this.data.city.label = _item.toponymName;
                                                this.data.city.value = _item.geonameId;
                                            }
                                        })
                                        this.comunities = data;
                                    })
                            }
                        }
                    });
                    // storage regions
                    this.regions = data;
                    this.disabledRegion = false;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });

                }
                });
            let parent = this.$auth.getParent();
            let url = doctor.speciality.listDoctor + '?country=' + this.$route.params.country;
            if(parent)
            {
                url = '&parent=' + parent;
            }
            // Get Specialities by country
            this.$http.post(url, {} ,{
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.specialities = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        data() {
            return {
                steps: {
                    'one': {
                        active: true,
                        valid: false
                    },
                    'two': {
                        active: false,
                        valid: false
                    },
                    'current': 'one',
                    'button': true
                },
                doctor: {},
                data: {
                    'name': '',
                    'street': '',
                    'number': '',
                    'region_id': '',
                    'region': { label: '', value: '' },
                    'comunity': '',
                    'comunity_id': '',
			'city': { label: '', value: '' },
                    'phone': '',
                    'duration': '',
                    'hour_confirm': '',
                    'specialities': [],
                    'add_user': false
                },
                placeholder_provincia: "Región", 
                regions: [],
                comunities: [],
                specialities: [],
                process: false,
                disabledRegion: true,
                disabled: true,
                errors: {
                    'name': {
                        'invalid': false,
                        'msg': ''
                    },
                    'street': {
                        'invalid': false,
                        'msg': ''
                    },
                    'number': {
                        'invalid': false,
                        'msg': ''
                    },
                    'region_id': {
                        'invalid': false,
                        'msg': ''
                    },
                    'comunity': {
                        'invalid': false,
                        'msg': ''
                    },
                    'phone': {
                        'invalid': false,
                        'msg': ''
                    },
                    'duration': {
                        'invalid': false,
                        'msg': ''
                    },
                    'speciality': {
                        'invalid': false,
                        'msg': ''
                    },
                    'hour_confirm': {
                        'invalid': false,
                        'msg': ''
                    },
                    'response': {
                        'invalid': false,
                        'msg': ''
                    }
                },
            }
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
                  // Get regions by country
            getRegionPlaceHolder(){
                if (this.$route.params.country == 'cl'){
                    this.placeholder_provincia = 'Region';
                }else{
                    this.placeholder_provincia = 'Provincia';
                }
            },
            // Validate step form
            next() {
                let error = false;
                if(this.steps.current == 'one')
                {
                    console.log(this.data);
                    // validate one
                    if(!this.data.name || this.data.name.length == 0 ||  this.data.name.length > 70)
                    {
                        this.errors.name.invalid = true;
                        this.errors.name.msg = this.translate.pages.office.add.validations.name;
                        error = true;
                    }else{
                        this.errors.name.invalid = false;
                        this.errors.name.msg = "";
                    }
                    if(!this.data.street || this.data.street.length == 0 || this.data.street.length > 80)
                    {
                        this.errors.street.invalid = true;
                        this.errors.street.msg = this.translate.pages.office.add.validations.street;
                        error = true;
                    }else{
                        this.errors.street.invalid = false;
                        this.errors.street.msg = "";
                    }
                    if(!this.data.number || this.data.number.length == 0 || this.data.number.length > 50)
                    {
                        this.errors.number.invalid = true;
                        this.errors.number.msg = this.translate.pages.office.add.validations.number;
                        error = true;
                    }else{
                        this.errors.number.invalid = false;
                        this.errors.number.msg = "";
                    }
                    if(!this.data.region.label || this.data.region.label == '')
                    {
                        console.log("region invalida")
                        this.errors.region_id.invalid = true;
                        this.errors.region_id.msg = this.translate.pages.office.add.validations.region_id;
                        error = true;
                    }else{
                        
                        this.errors.region_id.invalid = false;
                        this.errors.region_id.msg = "";
                    }
                    if(!this.data.city.label || this.data.city.label == '')
                    {
                        console.log("comuna invalida")
                        this.errors.comunity.invalid = true;
                        this.errors.comunity.msg = this.translate.pages.office.add.validations.comunity;
                        error = true;
                    }else{
                        this.errors.comunity.invalid = false;
                        this.errors.comunity.msg = "";
                    }
                    if(!this.data.phone || this.data.phone.length == 0 || this.data.phone.length > 20)
                    {
                        this.errors.phone.invalid = true;
                        this.errors.phone.msg = this.translate.pages.office.add.validations.phone;
                        error = true;
                    }else{
                        this.errors.phone.invalid = false;
                        this.errors.phone.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.steps.one.active = false;
                        this.steps.one.valid = true;
                        this.steps.two.active = true;
                        this.steps.button = false;
                        this.steps.current = "two";
                    }
                }else{
                    // validate two
                    if(this.data.specialities.length == 0)
                    {
                        this.errors.speciality.invalid = true;
                        this.errors.speciality.msg = this.translate.pages.office.add.validations.speciality;
                        error = true;
                    }else{
                        this.errors.speciality.invalid = false;
                        this.errors.speciality.msg = "";
                    }
                    if(this.data.duration.length == 0)
                    {
                        this.errors.duration.invalid = true;
                        this.errors.duration.msg = this.translate.pages.office.add.validations.duration;
                        error = true;
                    }else{
                        this.errors.duration.invalid = false;
                        this.errors.duration.msg = "";
                    }
                    if(this.data.hour_confirm.length == 0)
                    {
                        this.errors.hour_confirm.invalid = true;
                        this.errors.hour_confirm.msg = this.translate.pages.office.add.validations.hour_confirm;
                        error = true;
                    }else{
                        this.errors.hour_confirm.invalid = false;
                        this.errors.hour_confirm.msg = "";
                    }
                    if(error){
                        return false;
                    }else{
                        this.process = true;
                        this.data.region_id = this.data.region.value;
			            this.data.comunity_id = this.data.city.value;
                        this.data.comunity = this.data.city.label;
                        this.$http.post(doctor.api.offices, this.data, {
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                this.process = false;
                                let data = response.data.data;
                                let aditional = response.data.aditional;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        if(aditional){
                                            this.$store.dispatch('setSubordinate', aditional);
                                            this.$router.push({'name': 'Subordinate'});
                                        }else{
                                            this.$router.push({'name': 'Office'});
                                        }
                                    }, (dismiss) => {
                                        if(aditional){
                                            this.$store.dispatch('setSubordinate', aditional);
                                            this.$router.push({'name': 'Subordinate'});
                                        }else{
                                            this.$router.push({'name': 'Office'});
                                        }
                                    });
                            }).catch(error => {
                                this.process = false;
                                if(error.response.status === 401){
                                    if(error.response.data.msg.max_offices)
                                    {
                                        swal(this.translate.pages.office.add.title, error.response.data.msg.max_offices, 'warning');
                                    }
                                }
                                else if(error.response.status === 422){
                                    let data = error.response.data;
                                    for(let index in data)
                                    {
                                        this.errors[index].invalid = true;
                                        let messages = '';
                                        data[index].forEach( item => messages += item + ' ');
                                        this.errors[index].msg = messages;
                                    }
                                    this.errors.response.invalid = false;
                                }else if(error.response.status === 404){
                                    this.errors.response.invalid = true;
                                    this.errors.response.msg = error.response.data.message;
                                }else if(error.response.status === 500){
                                    this.errors.response.invalid = true;
                                    this.errors.response.msg = this.translate.pages.office.add.errors.response;
                                }
                            });
                    }
                }
            },
            // Validate step form
            previous() {
                this.steps.two.active = false;
                this.steps.one.active = true;
                this.steps.button = true;
                this.steps.current = 'one';
            },
            // On chosen speciality
            onChosen(add, speciality_id){
                if(add){
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = true;
                        }
                    });
                    this.data.specialities.push({"id": speciality_id});
                }else{
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = false;
                        }
                    });
                    this.data.specialities.find( (speciality, index) => {
                        if (speciality.id == speciality_id){
                            this.data.specialities.splice(index,1);
                            return false;
                        }
                    });
                }
            },
            // Change region
            changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.data.region.label = region.label
                        this.data.region.value = region.value
                        this.$http.post(public_api.api.cities, {region: this.data.region.value})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.comunities = data
                                this.data.city.label = ''
                                this.data.city.value = ''
                                this.disabledComunities = false
                            })
                    }
                }else{
                    this.comunities = []
                }
            },
            // Change City
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.comunities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.data.city.label = city.label
                        this.data.city.value = city.value
                    }
                }else{
                    this.data.city.label = ''
                    this.data.city.value = ''
                }
            },
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .OfficeAdd
        padding 3em 2.5em
        .header
            border 1px solid color_form_border
            border-radius 5px
            display flex
            font-size .9em
            font-weight bold
            justify-content space-around
            padding 1em 2em
            .step
                display flex
                cursor pointer
                .circle
                    border 1px solid color_form_border
                    border-radius 50%
                    height 18px
                    margin-right .5em
                    width 18px
                    &.active
                        background color_confirm
                        border-color color_confirm
                .active
                    color color_confirm
            .navigation
                height 2px
                background color_form_border
                min-width 60% !important
                margin-top .75em
        .content
            border 1px solid color_form_border
            border-radius 5px
            padding 1em 2em
            .h10
                height 10%
            .error
                color color_error !important
            &-header
                h3
                    margin-bottom 1em
            &-main
                .container
                    padding 0.25em 1em
                    .multiple
                        border 1px solid color_form_border
                        border-radius 5px
                        width 100%
                        &.error
                            border-color color_error !important
                            color rgba(0, 0, 0, .87) !important
                        .title
                            margin 0.5em
                            color color_form_placeholder
                        .select
                            overflow-y scroll
                            overflow-x hidden
                            margin 0.25em
                            height 110px
                            .option
                                width 95%
                                margin 0.25em
                    .subtitle
                        margin-top .5em
                        color color_form_placeholder
            &-footer
                margin-top 2em
                hr
                    background color_form_border
                    margin-bottom 1em
                    opacity 0.5
                min-height 5em
                .return
                    float left
                .next
                    float right
                    button
                        background color_main !important
                        color white
</style>
<style lang="stylus">
.select2 .open-indicator
    top 15px!important
    bottom auto!important
.masked_input span.md-error
    color red
    margin-left 15px

    .marcaagua{
    font-size: 10px;
    color: gray;
    }
.md-layout.container.md-input-container.masked_input.md-input-invalid:after
    background red
.masked_btn
    padding-top 5px !important
</style>
<style>
 .text--color {
    color: black !important;
 }
</style>




// WEBPACK FOOTER //
// Add.vue?5f82b8d2